import { styled as muiStyled } from '@mui/material';

import { Icon, Typography } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

interface StyledTypographyProps {
  error: string;
}

export const List = muiStyled('ul')(() => ({
  margin: 0,
  padding: 0,
  listStyleType: 'none',
  color: NEW_COLORS.GRAYSCALE[700],

  marginBottom: '.4rem',
}));

export const ErrorWrapper = muiStyled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const StyledTypography = muiStyled(Typography)<StyledTypographyProps>(
  ({ error = 'false' }) => ({
    fontWeight: '600',
    fontSize: '14px',
    color:
      error === 'true'
        ? NEW_COLORS.SEMANTICS.ERROR[500]
        : NEW_COLORS.SEMANTICS.SUCCESS[500],
    paddingLeft: '.2rem',
  }),
);

export const StyledIcon = muiStyled(Icon)(() => ({
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.5,
  },
}));

export const Container = muiStyled('div')(() => ({
  transform: 'translateY(-15px)',
}));

export const StyledForm = muiStyled('form')(() => ({
  marginTop: '52px',
  padding: '0 100px',
  marginBottom: '40px',
}));
